<!-- MainSearchMobile.vue -->
<template>
  <div id="search-bannerr-mobile" class="mt-4" ref="searchBannerMobile">
    <div class="container-banner-mobile">
      <div class="search-location">
        <img src="../../images/Loupe.png" @click="fetchSuggestions" v-set-alt class="icon" />
        <input
          class="raleway-reg-p15 search-bar-location"
          type="text"
          placeholder="Recherchez un hôtel, une destination"
          v-model="search"
          @input="fetchSuggestions"
        />
      </div>
      <div v-if="showSuggestions" class="suggestions-dropdown">
      <template v-for="(section, key) in suggestions">
        <div v-if="section.length" class="suggestion-group">
          <div class="suggestion-header">{{ sectionTitles[key] }}</div>
          <div
            v-for="(item, index) in section"
            :key="item.id"
            class="suggestion-card-wrapper"
          >
            <div class="suggestion-card" @click.stop="handleSuggestionClick(key, item)">
              {{ item.name }}
            </div>
            <div v-if="index !== section.length - 1" class="suggestion-divider"></div>
          </div>
        </div>
      </template>
    </div>
      <div class="search-details-mobile">
        <!-- Date Picker -->
        <div class="search-duration">
          <img src="../../images/3.png" v-set-alt class="iconn" />
          <CommonDatePicker
            :startDate="minDate"
            :endDate="maxDate"
            ref="datePicker"
            :autoHide="false"
            :showCloseButton="true"
            :closeButtonText="'SUIVANT'"
            @periodSelected="selectDates"
            @datepickerClosed="submitAndClose"
            @opened="isDatepickerOpen = true"
            @closed="isDatepickerOpen = false"
          />
        </div>

        <!-- Guest Info -->
        <div class="search-number" style="position: relative;"> <!-- Ensure this has position relative for dropdown to be positioned correctly -->
          <div class="d-flex flex-column">
            <div class="d-flex align-items-center">
              <img src="../../images/pers.png" v-set-alt class="iconn" style="width: 20px;height:25px;" />
              <div class="d-flex flex-column">
                <input
                  class="raleway-reg-p15 search-bar-top text-center"
                  @click="showGuestInfo = !showGuestInfo"
                  :placeholder="formatAdults()"
                />
                <input v-if="this.childs > 0"
                  class="raleway-reg-p15 search-bar-top text-center"
                  @click="showGuestInfo = !showGuestInfo"
                  :placeholder="formatChilds()"
                />

              </div>
              
            </div>
          </div>
          <MobileGuestInfo
            v-if="showGuestInfo"
            @ageSelected="updateAges"
            @increaseRooms="updateRooms"
            @decreaseRooms="updateRooms"
            @increaseChilds="updateChilds($event)"
            @decreaseChilds="updateChilds($event)"
            @increaseAdults="updateAdults($event)"
            @decreaseAdults="updateAdults($event)"
            @closed="handleClose"
            :initialAdults="adults"
            :initialChilds="childs"
            :initialChildAges="childAges"
          />
        </div>
      </div>

      <button class="hortense-btn-primary" :disabled="disableGoButton" @click="performSearch">
        <div class="search-button">{{ searchButtonCaption }}</div>
      </button>
    </div>
  </div>
</template>
  
  <script>
  import MobileGuestInfo from "components/btns/MobileGuestInfo.vue";
  import { VueDatePicker } from "@mathieustan/vue-datepicker";
  import fetcher from '../../packs/shared/api.js';
  import _ from 'lodash';

  export default {
    name: "MainSearchMobile",
    components: { MobileGuestInfo, VueDatePicker },
    data() {
      return {
        search: "",
        selectedDates: [],
        showGuestInfo: false,
        rooms: 1,
        childs: 0,
        adults: 2,
        childAges: [],
        currentDate: new Date(),
        searchResults: null,
        suggestions: {
        lodgings: [],
        departments: [],
        regions: [],
        cities: [],
        zones: [],
        territoires: [],
      },
      isDatepickerOpen: false,
      sectionTitles: {
        lodgings: 'Hébergements',
        departments: 'Départements',
        regions: 'Régions',
        cities: 'Villes',
        zones: 'Destinations',
        territoires: 'Destinations'
      },
      showSuggestions: false,
      };
    },
    methods: {
      submitAndClose() {
        this.isDatepickerOpen = false;
        this.toggleBurgerButtonBasedOnCalendar();
      },

      checkDatepickerOpen() {
        this.isDatepickerOpen = true;
        if (this.isDatepickerOpen) {
          document.body.style.overflow = 'hidden';
          document.body.style.height = '100vh';
        } else {
          document.body.style.overflow = '';
          document.body.style.height = '';
        }
      },
      handleClose() {
        this.showGuestInfo = false;
      },
      selectDates(event, start, end) {
        this.selectedDates = [this.formatDate(start), this.formatDate(end)];
        const state = {
          koediaFrom: this.formatKoediaDate(this.formatDate(start)),
          koediaTo: this.formatKoediaDate(this.formatDate(end)),
          from: this.formatKoediaDate(this.formatDate(start)),
          to: this.formatKoediaDate(this.formatDate(end)),
        };
        this.persistReservationState(state);
      },
      handleSuggestionClick(type, item) {
      this.search = item.name;
      this.showSuggestions = false;
    },
    formatDate(date) {
      if (!date) return null;
      const set = new Date(date);
      const options = { year: "numeric", month: "numeric", day: "numeric" };
      return set.toLocaleString("fr", options);
    },
    formatKoediaDate(date) {
        if (date) {
          if (date.includes('-') || !date) {
            return date;
          }
          const dateBits = date.split('/');
          return `${dateBits[2]}-${dateBits[1]}-${dateBits[0]}`;
        } else {
        return null;
        }
    },
    async performSearch() {
      try {
        const trimmedSearch = this.search ? this.search.trim() : '';
        const path = window.location.pathname;
        const existingState = this.getReservationState();

        const fromDate = this.selectedDates && this.selectedDates[0]
          ? this.formatKoediaDate(this.selectedDates[0])
          : (existingState.koediaFrom || existingState.from || null);
        const toDate = this.selectedDates && this.selectedDates[1]
          ? this.formatKoediaDate(this.selectedDates[1])
          : (existingState.koediaTo || existingState.to || null);

        const reservationState = {
          search: trimmedSearch,
          childs: this.childs,
          adults: this.adults,
          children_ages: this.normalizeChildAges(this.childAges),
          koediaFrom: fromDate,
          koediaTo: toDate,
          from: fromDate,
          to: toDate,
          base: path.includes("/vacances-printemps") ? 'spring' : path.includes("/vacances-ete") ? 'summer' : ''
        };

        if (!this.persistReservationState(reservationState)) {
          return;
        }

        // Wait for dataLayer to process
        this.trackSearch();
        await new Promise(resolve => setTimeout(resolve, 100));

        // Navigate
        window.location.href = `/reservation-hotel`;
      } catch (error) {
        console.error('Search error:', error);
        this.isSearching = false;
      }
    },
    trackSearch() {
      window.dataLayer = window.dataLayer || [];
      let bookingWindow = null;

      if (this.selectedDates && this.selectedDates[0]) {
        const dateInParts = this.selectedDates[0].split('/');
        const dateIn = new Date(`${dateInParts[2]}-${dateInParts[1]}-${dateInParts[0]}`);
        const today = new Date();
        const timeDifference = dateIn - today;
        bookingWindow = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
      }

      const dateIn = this.selectedDates ? this.selectedDates[0] : null;
      const dateOut = this.selectedDates ? this.selectedDates[1] : null;

      const numberOfNights = (dateIn && dateOut)
        ? Math.ceil((new Date(dateOut) - new Date(dateIn)) / (1000 * 60 * 60 * 24))
        : null;

      window.dataLayer.push({
        event: 'search',
        ecommerce: {
          search_term: this.search,
          booking_window: bookingWindow,
          date_in: this.selectedDates ? this.formatKoediaDate(this.selectedDates[0]) : null,
          date_out: this.selectedDates ? this.formatKoediaDate(this.selectedDates[1]) : null,
          number_of_people: parseInt(this.adults || 2) + parseInt(this.childs || 0),
          number_of_adult: this.adults,
          number_of_child: this.childs,
          results: 93,
          number_of_nights: numberOfNights
        }
      });
    },
    updateRooms(room) {
      this.rooms = room;
      this.$emit("numberOfRoom", this.rooms);
    },
    formatRooms() {
      let chambre = " Chambre";
      if (this.rooms > 1) {
        chambre += "s";
      }
      return this.rooms + chambre;
    },
    updateChilds(child) {
      this.childs = child;
      this.persistReservationState({ childs: child });
      this.$emit("numberOfChild", this.childs);
    },
    updateAdults(adult) {
      this.adults = adult;
      this.persistReservationState({ adults: adult });
      this.$emit("numberOfAdult", this.adults);
    },
    updateAges(value) {
      this.childAges = this.normalizeChildAges(value);
      this.persistReservationState({ children_ages: this.childAges });
      this.$emit("ageOfChild", this.childAges);
    },
    formatAdults() {
      let adulte = " Adulte";
      if (this.adults > 1) {
        adulte += "s";
      }
      return this.adults + adulte;
    },
      formatChilds() {
        let enfant = " Enfant";
        if (this.childs > 1) {
          enfant += "s";
        }
        return this.childs + enfant;
      },
      fetchSuggestions() {
      if (this.search.length < 3) {
        this.resetSuggestions();
        this.showSuggestions = false;
        return;
      }
      // Call the debounced function
      this.debouncedFetchSuggestions();
    },
    resetSuggestions() {
      this.suggestions = { lodgings: [], departments: [], regions: [], cities: [], zones: [], territoires: [] };
    },
    goToAccommodation(id) {
      window.open(`/reservation-hotel/${id}`, '_blank');
    },
    goToDestination(slug) {
      window.open(`/destination/${slug}`, '_blank');
    },
    goToDestinationTwo(id){
      window.open(`/reservation-hotel?zone=${id}`, '_blank');
    },
    goToDestinationThree(id){
      window.open(`/reservation-hotel?territoire=${id}`, '_blank');
    },
    handleClickOutside(event) {
      if (this.$refs.searchInput && !this.$refs.searchInput.contains(event.target)) {
        this.showSuggestions = false;
      }
    },
    toggleBurgerButtonBasedOnCalendar() {
      const burgerButton = document.getElementsByClassName('bm-burger-button')[0];
      const calendarOpen = document.querySelector('.vhd__datepicker--open');
      
      if (burgerButton) {
        if (calendarOpen) {
          // Calendar is open, hide burger button
          burgerButton.style.display = 'none';
        } else {
          // Calendar is closed, show burger button
          burgerButton.style.display = 'block';
        }
      }
    },
    setupCalendarObserver() {
      // Create a MutationObserver to watch for calendar state changes
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            this.toggleBurgerButtonBasedOnCalendar();
          }
        });
      });

      // Observe changes to the document body and all child elements
      observer.observe(document.body, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class']
      });

      // Store observer reference for cleanup
      this.calendarObserver = observer;
    },
    getReservationState() {
      return JSON.parse(localStorage.getItem('reservationState') || '{}');
    },
    normalizeChildAges(ages) {
      if (!Array.isArray(ages)) return [];
      return ages
        .map((age) => age?.toString?.().trim())
        .filter((age) => Boolean(age));
    },
    hasMissingChildAges() {
      if (!this.childs) return false;
      return this.normalizeChildAges(this.childAges).length < this.childs;
    },
    persistReservationState(partialState = {}) {
      if (this.childs > 0 && this.hasMissingChildAges()) {
        this.showGuestInfo = true;
        return false;
      }

      const reservationState = this.getReservationState();
      localStorage.setItem(
        'reservationState',
        JSON.stringify({
          ...reservationState,
          ...partialState,
          adults: this.adults,
          childs: this.childs,
          children_ages: this.normalizeChildAges(this.childAges),
        })
      );
      return true;
    },
  },
    beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
    // Clean up the observer
    if (this.calendarObserver) {
      this.calendarObserver.disconnect();
    }
    // Cancel any pending debounced calls
    if (this.debouncedFetchSuggestions) {
      this.debouncedFetchSuggestions.cancel();
    }
    // Show burger button when component is destroyed
    const burgerButton = document.getElementsByClassName('bm-burger-button')[0];
    if (burgerButton) {
      burgerButton.style.display = 'block';
    }
  },
    mounted() {
      document.addEventListener('click', this.handleClickOutside);
      // Setup the calendar observer
      this.setupCalendarObserver();
      // Initial check for calendar state
      this.toggleBurgerButtonBasedOnCalendar();
      
      // Create debounced version of the API call
      this.debouncedFetchSuggestions = _.debounce(async () => {
        try {
          const response = await fetcher.get(`/lodgings/search_suggestions?query=${this.search}&geo=48.8575,2.3514`);
          this.suggestions = response.data;
          this.showSuggestions = true;
        } catch (error) {
          console.error('Error fetching suggestions', error);
        }
      }, 500);

      const state = this.getReservationState();
      this.search = state.search || this.search;
      this.adults = state.adults || this.adults;
      this.childs = state.childs || this.childs;
      this.childAges = Array.isArray(state.children_ages)
        ? this.normalizeChildAges(state.children_ages)
        : this.childAges;
      if ((state.koediaFrom || state.from) && (state.koediaTo || state.to)) {
        this.selectedDates = [
          state.koediaFrom || state.from,
          state.koediaTo || state.to,
        ];
      }
    },
    computed: {
      searchButtonCaption() {
        return this.isSearching ? "Recherche..." : "RECHERCHER";
      },
      disableGoButton() {
        return false;
      },
      minDate() {
        return new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), this.currentDate.getDate());
      },
      maxDate() {
        return new Date(this.currentDate.getFullYear() + 1, this.currentDate.getMonth(), this.currentDate.getDate());
      },
    },
    watch: {
      isDatepickerOpen(newVal) {
        console.log('isDatepickerOpen',newVal)
        const bPhoneElement = document.getElementById('b-phone');
        if (bPhoneElement) {
          if (newVal) {
            bPhoneElement.style.zIndex = '103';
          } else {
            bPhoneElement.style.zIndex = '';
          }
        }
      }
    }
  };
  </script>
  
  <style lang="scss" rel="stylesheet">
  @media only screen and (min-device-width : 320px) and (max-device-width : 480px) {
    .vhd__hide-on-desktop{
      display: none;
    }
  .vhd__datepicker__clear-button{
    left:102% !important
  }
  .vhd__datepicker__clear-button svg {
    left: 150% !important;
}
#search-bannerr-mobile {
  input[type="text"]:focus {
    outline: none;
    border: none;
    box-shadow: none;
  }
} 

input[type="text"]:focus {
  outline: none;
}

.vhd__datepicker__week-days {
  visibility: visible !important;
  height: auto !important;
  margin-bottom: 10px;
}
.datepicker__week-row{
  visibility: visible !important;
  height: auto !important;
  margin-bottom: 10px;
}

.vhd__datepicker__week-row{
  visibility: visible !important;
  height: auto !important;
  margin-bottom: 10px;
}

.vhd__hide-up-to-tablet {
    display: flex !important;
    visibility: visible !important;
    height: auto !important;
    overflow: hidden;
    width: 100%;
  }


  #search-bannerr-mobile {
    padding: 1rem;
    width: 100%;
    margin: 0 auto;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border: 1px solid #e0e0e0;
    background: #fff;
    box-shadow: 5px 3px 6px #00000029;
  }

  .search-duration::after {
  content: "";
  display: block;
  width: 3px;
  height: 70%;
  background-color: #dcd8d8;
  margin-left: 30px;
}
  
  .container-banner-mobile {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
  }
  
  .search-details-mobile {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  
  .search-location {
    display: flex;
    align-items: center;
    width: 100%;
  }

  .search-duration {
    display: flex;
    align-items: center;
    width: 80%;
  }

  @media only screen and (max-device-width: 480px) {
    .search-duration {
    width: 60% !important;
  }
  }

  .search-number {
    display: flex;
    align-items: center;
    width: 42%;
    margin-left: 4vw;
  }
  
  .hortense-btn-primary {
    margin-top: 1rem;
    padding: 8px 16px;
    background-color: #3b6152;
    color: white;
    border: none;
    cursor: pointer;
    width: 98% !important;
    height: 6vh !important;
  }
  
  .icon {
    margin-right: 0.5rem;
  }

  .iconn {
    margin-right: 0.1rem;
  }
  
  .search-bar-location,
  .search-bar-top {
    background-color: white;
    border-width: 0px !important;
    /* border-bottom: 1px solid black !important; */
    /* padding-bottom: 0.5rem; */
    width: 100%;
  }
  
  .search-bar-location::placeholder,
  .search-bar-top::placeholder {
    color: black;
  }
  .suggestions-dropdown {
background: #f9f9f9;
border-radius: 8px;
margin-top: 8px;
box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
max-height: 400px;
padding: 15px 0;
overflow-y: hidden;
font-family: Raleway;
width: 100%;
}

.suggestion-group {
margin-bottom: 20px;
}

.suggestion-header {
font-weight: bold;
font-size: 14px;
color: #3b6152;
padding: 10px 20px 5px;
text-transform: uppercase;
background: transparent;
font-family: Raleway;
}

.suggestion-card-wrapper {
padding: 0 20px;
}

.suggestion-card {
font-size: 16px;
color: #3b6152;
cursor: pointer;
padding: 10px 0;
font-family: Raleway;
}

.suggestion-card:hover {
background: #eef3f0;
}

.suggestion-divider {
width: 100%;
height: 1px;
background: #3b6152;
}
  }
@media only screen and (min-device-width : 320px) and (max-device-width : 480px) {
.vhd__datepicker--open{
    // height: 85% !important;
    margin-top: auto !important;
  }
  .vhd__datepicker__close-button{
    font-weight: 500 !important;
    top: 13.5% !important;
    right: 10px !important;
    font-size: 30px !important;
  }
  .vhd__datepicker__month-day--first-day-selected,
  .vhd__datepicker__month-day--last-day-selected {
    background-color: #3b6152 !important;
    border-radius: 5px !important;
  }
  .vhd__datepicker__month-day--selected{
    color: black !important;
  }

  .vhd__datepicker__month-day--valid.vhd__datepicker__month-day--not-allowed{
    background-color: #3b6152 !important;
    color: white !important;
    border-radius: 5px !important;
  }

  .vhd__datepicker__month-day--allowed-checkout:hover, .vhd__datepicker__month-day--valid:hover {
    background-color: white !important;
    color: #000 !important;
    border-radius: 5px !important;
  }
  .vhd__datepicker__month{
    font-size: 13px !important;
  }
  .vhd__datepicker__month-day--today .vhd__datepicker__month-day-wrapper{
    border: 2px solid #3b6152 !important;
    border-radius: 5px !important;
  }
  .vhd__datepicker__month-day-wrapper{
    border-radius: 5px !important;
  }
  .vhd__datepicker__months-wrapper::-webkit-scrollbar {
    display: none !important;
  }
  .vhd__datepicker__months::-webkit-scrollbar{
    display: none !important;
  }
  .close-date-picker{
    margin-top: 1rem;
    padding: 8px 16px;
    background-color: #3b6152;
    color: white;
    border: none;
    cursor: pointer;
    width: 90% !important;
    height: 6vh !important;
    z-index: 9999;
    position: fixed;
    bottom: 5px;
    left: 50%;
    transform: translateX(-50%);
  }
}
  </style>
